<template>
    <div>
        <!-- Modal -->
        <div class="modal fade" id="editarLoteFabricModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-lg modal-dialog-scrollable" role="document">
                <div class="modal-content" v-if="lote">
                    <div class="modal-header">
                        <h5 class="modal-title">Lote</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="alert alert-info d-flex justify-content-between" v-if="material">
                            <span>{{ material.st_estoque_item }}</span>
                            <span>#{{ material.id_estoque_item }}</span>
                        </div>

                        <div class="mb-3">
                            <h3 class="mb-0">{{ lote.st_lote }}</h3>
                            <div class="small text-muted">#{{ lote.id_estoque_lote }}</div>
                        </div>

                        <az-input
                            label="Fabricante"
                            required
                            :validate="validate"
                            placeholder="Informe o fabricante..."
                            v-model="lote.st_fabricante" />
                    </div>
                    <div class="modal-footer">
                        <az-audit-log-button model="estoqueLote" :id="lote.id_estoque_lote" />
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
                        <az-submit @click="atualizar()">Atualizar</az-submit>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import $ from 'jquery';
import AzInput from '../../shared/forms/AzInput.vue';
import AzSubmit from '../../util/AzSubmit.vue';
import AzAuditLogButton from '../../util/AzAuditLogButton.vue';

export default {
    data() { 
        return { 
            lote: null,
            material: null, 
            validate: false, 
        }
    }, 

    components: { 
        AzInput,
        AzSubmit,
        AzAuditLogButton,
    },

    methods: { 
        abrir(lote, material = null) { 
            this.material = material;
            this.validate = false;

            this.$util.loadItem(this, { 
                service: 'estoque_lotes',
                func: 'show',
                parms: { 
                    id: lote.id_estoque_lote
                }
            })
            .then(res => { 
                this.lote = res; 
                $('#editarLoteFabricModal').modal('show');
            });
        },

        atualizar() { 
            this.$util.atualizar(this, { 
                service: 'estoque_lotes',
                func: 'store',
                dados: {
                    id_estoque_lote: this.lote.id_estoque_lote,
                    st_fabricante: this.lote.st_fabricante,
                },
                modal: 'editarLoteFabricModal',
                toast: true, 
                callback: () => { 
                    this.$emit('refresh');
                }
            });
        }
    }
}
</script>